import type { ReactNode } from 'react';

/** Marco de las páginas públicas del lead: con la imagen de la organización, no la de VIDA. */
export function LeadPublicShell({ org, children }: { org: { name: string; logoUrl: string | null } | null; children: ReactNode }) {
  return (
    <div className="min-h-screen bg-gray-50 px-4 py-10">
      <div className="w-full max-w-xl mx-auto">
        {org && (
          <div className="flex items-center gap-3 mb-6">
            {org.logoUrl && <img src={org.logoUrl} alt="" className="h-10 w-auto max-w-[160px] object-contain" />}
            <span className="text-base font-semibold text-gray-900">{org.name}</span>
          </div>
        )}
        <div className="bg-white rounded-xl border border-gray-200 p-6 sm:p-8">{children}</div>
      </div>
    </div>
  );
}
